export default {
  firstTip: '於申請開通結構性產品交易前，請先詳細閱讀',
  linkTitle: '「結構性產品相關風險聲明披露」',
  lastTip: '，並觀看香港交易所網站的股票期權教育短片。 ',
  languageVideo: '短片語言',
  pdfLink: 'http://download.eddidapp.com/pdf/SC/risks-of-structured-products-disclosure-statement.pdf',
  yyType: '粵語版',
  ptType: '普通話版',
  problems: [{
    title: '1.簡介香港交易所網站的股票期權專頁',
    quTitle: '本片將重點講解：',
    // 簡體，繁體
    src: ['http://download.eddidapp.com/video/SC/Simplified1.mp4', 'http://download.eddidapp.com/video/TC/Traditional1.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/FB_Video1 .jpg?la=zh-HK&hash=060F2AB3B8649FF23E3315EDA28EBA1CC28C31BD',
    content: [
      '• 香港交易所期權專頁如何能協助您建構投資策略？ ',
      '• 新增的十個期權工具是什麼？ '
    ]
  }, {
    title: '2.如何用股票期權複製Bull ELN ',
    quTitle: '本片將重點講解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified2.mp4', 'http://download.eddidapp.com/video/TC/Traditional2.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/course1_tc .jpg?la=zh-HK&hash=0D2A99403414776974EF429C79967E0B0F8AF602',
    content: [
      '• 什麼是Bull ELN？ ',
      '• 投資者可以如何運用交易所買賣的股票期權以達到相同的回報？ ',
      '• 這個投資策略適合什麼類型的投資者？ '
    ]
  }, {
    title: '3.透過股票期權提高收入',
    quTitle: '本片將重點講解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified3.mp4', 'http://download.eddidapp.com/video/TC/Traditional3.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/course2_tc .jpg?la=zh-HK&hash=09956EE25354CC749735C96939B6B4226317584F',
    content: [
      '• 如果你已持有一隻股票，除每年獲發數次股息外，你可怎樣運用交易所買賣的股票期權以提高回報呢？ '
    ]
  }, {
    title: '4. 期權買賣–場內還是場外交易?',
    quTitle: '本片將重點講解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified4.mp4', 'http://download.eddidapp.com/video/TC/Traditional4.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/FB_Video2 .jpg?la=zh-HK&hash=4BB39BC4DC6DCF4C55733ED562D54D2C856CDE6A',
    content: [
      '• 場內及場外交易有什麼不同? ',
      '• 兩種交易平台的好處及壞處是什麼? '
    ]
  }, {
    title: '5.引申波幅',
    quTitle: '本片將重點講解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified5.mp4', 'http://download.eddidapp.com/video/TC/Traditional5.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/FB_Video3 .jpg?la=zh-HK&hash=8EE76EB26E9731715D6C4F2BD9BD610D21D5FE37',
    content: [
      '• 什麼是引申波幅?',
      '• 投資者可怎樣比較不同行使價的期權的價格? '
    ]
  }, {
    title: '6. 尋找期權報價',
    quTitle: '本片將重點講解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified6.mp4', 'http://download.eddidapp.com/video/TC/Traditional6.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/FB_Video4 .jpg?la=zh-HK&hash=65CD0D59646534F57F34291BB3F9545E3EEE1A5C',
    content: [
      '• 如何獲得股票期權報價? ',
      '• 要求報價功能 '
    ]
  }, {
    title: '7. 期權買賣差價解讀',
    quTitle: '本片將重點講解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified7.mp4', 'http://download.eddidapp.com/video/TC/Traditional7.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/FB_Video5 .jpg?la=zh-HK&hash=E79BAE96C58EBFDC538F8FB9462A3551B5C4DB1E',
    content: [
      '• 什麼是買賣差價? ',
      '• 有什麼因素影響股票期權買賣差價? '
    ]
  }, {
    title: '8. 期權為投資組合帶來的好處',
    quTitle: '本片將重點講解：',
    src: ['http://download.eddidapp.com/video/SC/Simplified8.mp4', 'http://download.eddidapp.com/video/TC/Traditional8.mp4'],
    bgImg: 'https://www.hkex.com.hk/-/media/HKEX-Market/Products/Listed-Derivatives/Single-Stock/Stock-Options/Options-Education/Online-Courses-Podcast-Channel/FB_Video6 .jpg?la=zh-HK&hash=7819DCFF7DABE3423C56059F781E277C6665C318',
    content: [
      '• 什麼是槓桿效應? ',
      '• 什麼是增進收益率? '
    ]
  }],
  // one: '1. 簡介香港交易所網站的股票期權專頁',
  // quTitle: '本片將重點講解：',
  // oneCon1: '• 香港交易所期權專頁如何能協助您建構投資策略？ ',
  // oneCon2: '• 新增的十個期權工具是什麼？ ',
  // two: '2. 如何用股票期權複製Bull ELN',
  // twoCon1: '• 什麼是Bull ELN',
  // twoCon2: '• 投資者可以如何運用交易所買賣的股票期權以達到相同的回報？ ',
  // twoCon3: '• 這個投資策略適合什麼類型的投資者？ ',
  firstReadTip: '於申請開通結構性產品交易前, 請先詳細閱讀',
  lastReadTip: '',
  firstCheckTip: '本人欲買賣衍生品權證、牛熊證及結構性產品及本人特此確認，本人已明白買賣衍生權證、牛熊證及結構性產品的風險並已詳細閱讀',
  lastCheckTip: '本人確認本人之所有資料與開戶時所提交的資料相同',
  btn: '提交申請',
  btn1: '已提交',
  errorChecked: '請確認已詳細閱讀「結構性產品和香港風險聲明披露」',
  submitTip: '您的申請已經成功提交，我們將在3個工作日內進行審核，您可以撥打+852 2655 0338 / 400 120 0068（中國內地免費熱線）與我們聯繫。 ',
  failureTip: '您的申請已被拒絕，您可以撥打+852 2655 0338 / 400 120 0068（中國內地免費熱線）與我們聯繫，或者重新提交申請。 ',
  success: '您的結構性交易產品申請已成功提交,如有問題請與我們聯繫。 ',
  completedTip: '您的申請已經審核通過，您可以進行結構性產品交易。 ',
  shenqingTip: '請先申請證券賬號',
  errorMsg: {
    '10002': '已經存在結構性申請記錄，勿重複提交'
  },
  titleTip: '衍生品相關經驗',
  infomationTips1: '本人曾接受有關衍生產品性質和風險的一般知識培訓或修讀相關課程',
  infomationTips2: '本人在過去3年曾執行5次或以上有關衍生產品的交易，例如：衍生證券、牛熊市、股票期權、期貨與期權、商品、結構性產品及交易所買賣基金等',
  infomationTips3: '本人從現在或過去擁有過與衍生產品有關的工作經驗',
  notSameInfo: '於申請開通結構性產品交易前，請確認資料是否有更改，如有，請聯繫客服+852 2655 0338 / 400 120 0068（中國內地免費熱線） | 電郵: cs@eddidsec.com',
  oneInfo: '由於您：選擇開通結構性產品，必須勾選至少一項衍生品相關經驗',
  riskTip: '艾德證券期貨已根據以上的資料對客戶進行評估，並已通知客戶買賣有關衍生產品前必須先具備足夠的認識，及提示客戶有關 衍生產品之性質及風險。',
   hasExchange: '閣下是否曾於過去三年曾執行五次或以上衍生工具的交易，例如：衍生權證、牛熊證、股票期權、期貨及期權、結構性產品等？',
  hasWorkExperience: '閣下是否曾經取得衍生工具的工作經驗？',
  hasTraining: '閣下是否曾經接受衍生工具的培訓或修讀相關課程？',
  derivativesCheckedTip: '閣下未能提供相關證明文件，請仔細閱讀',
  derivativesCheckedTipLast: '並填寫「第二部分 - 衍生工具知識問卷」以完成此評估。',
  derivativesBasic: '「衍生產品基本知識」',
  derivativesBasicLink: 'https://download.eddidapp.com/pdf/TC/GeneralKnowledgeonDerivativesProducts.pdf',
  transactionNotesTitle: '請提供相關文件證明，例如：成交單據、戶口結單等等',
  licenseeCardTitle: '請提供相關資料／文件證明，例如：持牌人中央編號名片等',
  certificateTitle: '請提供相關文件證明，例如：證書等',
  uploadProof: '證明文件',
  tradingtime: '交易時間',
  relatedfinancialinstitutions: '相關金融機構',
  producttypes: '產品種類',
  employername: '僱主名稱',
  position: '職位',
  yearsofemployment: '工作年期',
  nameoftrainingorcourse: '培訓或修讀課程的名稱',
  dateoftrainingorcourse: '培訓或修讀以上課程的日期',
  pleaseCheckBasics: '請勾選“閣下未能提供相關證明文件，請仔細閱讀「衍生產品基本知識」並填寫「第二部分 - 衍生工具知識問卷」以完成此評估。”',
  customerConfirmationTitle: '客戶確認及聲明',
  derivativesKnowledgeTitle: '衍生工具知識問卷',
  customerConfirmationOne: '本人/吾等確認上述資料完全真實及完整，並明白艾德將根據上述資料評估本人/吾等是否擁有對衍生產品之知識，以符合《證券及期貨事務監察委員會持牌人或註冊人操守準則》之有關要求。',
  customerConfirmationTwo: '本人/吾等明白於本表格上提供資料為評估本人/吾等對衍生工具的知識是自願的。倘本人/吾等未能提供有關資料，是次之評估將不獲處理。',
  customerConfirmationThree: '本人/吾等已仔細閱讀及完全明白，由艾德提供，並以本人/吾等所選擇之語言（英文或中文）的 ',
  customerConfirmationFour: '本人/吾等並願意承擔交易相關在交易所買賣的衍生產品所帶來的潛在風險。',
  explanatoryNote: '「交易所買賣衍生產品風險說明｣ ',
  explanatoryNoteLink: 'https://download.eddidapp.com/pdf/TC/RisksAssociatedwithDerivativeProducts.pdf',
  customerConfirmationThreeLast: '本人/吾等確認假若本人對該文件有任何疑問，本人/吾等應當尋求獨立專業意見。本人/吾等並且確認該文件不能披露投資衍生產品可能涉及的所有風險，與及本人/吾等須就投資這些產品作出本人自己的判斷，並確保本人/吾等擁有充分的淨資產以承擔風險及潛在的損失。',
  unfinishedReminder: '請完成問卷。',
  exceededlimitTip: '衍生工具知識問卷每日評估次數不能超過兩次。閣下可以按 [繼續開戶申請] 完成餘下的開戶流程，但在通過衍生工具知識問卷之前，閣下將被禁止進行衍生工具相關的交易。',
  continue: '繼續開戶申請',
  evaluationResults: '評估結果',
  lackofknowledge: '不具備衍生工具知識',
  exceededtwicelimitTip: '衍生工具知識問卷每日評估次數不能超過兩次。如有疑問，請聯絡客戶服務主任。電話：+852 2655 0338 / 400 120 0068（中國內地免費熱線） 電郵：cs@eddidsec.com',
  viewResults: '查看結果',
  derivativesKnowledgeResult: '問卷結果',
  jobDuties: '工作職責',
  needCondition: '抱歉，你未開立證券交易賬戶，無法申請交易結構性產品，如有需要可申請開立證券交易賬戶。',
  btnReEvaluate: '重新評估',
  agree: '你需要閱讀並勾選相關協議'
}
